var _path, _g, _path2, _g2, _circle, _path3, _g3, _rect, _path4, _rect2, _path5, _rect3, _circle2, _circle3, _circle4, _path6, _path7, _path8, _path9, _path10, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceEncouragingSomeone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 139,
    viewBox: "0 0 284 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 100C62.6731 100 77 85.6731 77 68C77 50.3269 62.6731 36 45 36C27.3269 36 13 50.3269 13 68C13 85.6731 27.3269 100 45 100Z",
    fill: "#EC1D4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4477 52.8235C41.0202 50.9915 42.7169 49.7441 44.6363 49.7441C47.1676 49.7441 49.174 51.8799 49.0161 54.4062L48.5895 61.2313L49.3075 81.3339H39.2562C38.4632 81.3339 37.8203 80.691 37.8203 79.898V62.1079C37.8203 61.5269 37.9085 60.9492 38.0818 60.3947L40.4477 52.8235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2309 61.2305H56.6452C59.9841 61.2305 62.3947 64.4263 61.4774 67.6368L58.9032 76.6466C58.1106 79.4206 55.5752 81.333 52.6903 81.333H42.4873L48.2309 61.2305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7695,
    y: 61.2305,
    width: 8.61539,
    height: 20.1026,
    rx: 1.4359,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 100C158.673 100 173 85.6731 173 68C173 50.3269 158.673 36 141 36C123.327 36 109 50.3269 109 68C109 85.6731 123.327 100 141 100Z",
    fill: "#EC1D4F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.448 52.8235C137.02 50.9915 138.717 49.7441 140.636 49.7441C143.168 49.7441 145.174 51.8799 145.016 54.4062L144.59 61.2313L145.307 81.3339H135.256C134.463 81.3339 133.82 80.691 133.82 79.898V62.1079C133.82 61.5269 133.908 60.9492 134.082 60.3947L136.448 52.8235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.231 61.2305H152.645C155.984 61.2305 158.395 64.4263 157.477 67.6368L154.903 76.6466C154.111 79.4206 151.575 81.333 148.69 81.333H138.487L144.231 61.2305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.77,
    y: 61.2305,
    width: 8.61539,
    height: 20.1026,
    rx: 1.4359,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237 108C259.091 108 277 90.0914 277 68C277 45.9086 259.091 28 237 28C214.909 28 197 45.9086 197 68C197 90.0914 214.909 108 237 108Z",
    fill: "#EC1D4F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.31 49.0289C232.025 46.7389 234.146 45.1797 236.545 45.1797C239.71 45.1797 242.218 47.8493 242.02 51.0073L241.487 59.5387L242.384 84.6669H229.82C228.829 84.6669 228.025 83.8633 228.025 82.872V60.6343C228.025 59.9081 228.136 59.1861 228.352 58.4929L231.31 49.0289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.039 59.5391H251.557C255.73 59.5391 258.744 63.5338 257.597 67.5469L254.379 78.8092C253.389 82.2767 250.219 84.6673 246.613 84.6673H233.859L241.039 59.5391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.462,
    y: 59.5391,
    width: 10.7692,
    height: 25.1282,
    rx: 1.79487,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 98L169.5 102L176.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 98L73.5 102L80.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 122.5L212 135.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 126L271 135",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273 27L281.5 14",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 14.5L219.5 3",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 35.5L180.5 27",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 18,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 137,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 109.5,
    r: 1.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4615,
    height: 31.5897,
    fill: "white",
    transform: "translate(27.7695 49.7441)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4615,
    height: 31.5897,
    fill: "white",
    transform: "translate(123.77 49.7441)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.0769,
    height: 39.4872,
    fill: "white",
    transform: "translate(215.462 45.1797)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceEncouragingSomeone);
export default __webpack_public_path__ + "static/media/persistence-encouraging-someone.5eb7561b000c51512c545b5c9d049087.svg";
export { ForwardRef as ReactComponent };